var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFalse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7995 31.5332C44.7328 34.3199 44.7328 39.0133 41.7995 41.8C39.0128 44.7333 34.3205 44.7333 31.5333 41.8L22 32.4132L12.4662 41.8C9.67951 44.7333 4.98716 44.7333 2.2 41.8C-0.733333 39.0133 -0.733333 34.3199 2.2 31.5332L11.5862 22.0003L2.2 12.4664C-0.733333 9.67971 -0.733333 4.98634 2.2 2.19965C4.98667 -0.733217 9.67902 -0.733217 12.4662 2.19965L22 11.5864L31.5338 2.19965C34.3205 -0.733217 39.0128 -0.733217 41.8 2.19965C44.7333 4.98634 44.7333 9.67971 41.8 12.4664L32.4138 22.0003L41.7995 31.5332Z",
    fill: "#FF3E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalse);
export default __webpack_public_path__ + "static/media/false.e08545ede5f000144292fc9c31b46497.svg";
export { ForwardRef as ReactComponent };